import { useState, useCallback, useMemo } from "react";
import { login, logout, checkCode, sendCard, getSettings, findProduct } from './Api';

/**ФВП получает на входе асинхронную ф-цию из АПИ, а на выходе возвращает готовый хук для работы с ней */
const createUseFunction = (apiSender) => () => {
    const [err, setErr] = useState(undefined);
    const [data, setData] = useState(undefined);

    const sender = useCallback((sendData) => {
        setErr(undefined);
        setData(undefined);
        apiSender(sendData)
            .then(result => setData(result))
            .catch(error => setErr(error))

    })

    const reset = useCallback(() => {
        setErr(undefined);
        setData(undefined);
    })

    const result = useMemo(() => [data, err, sender, reset], [err, data]);

    return result;
}

/**ФВП получает на входе асинхронную ф-цию из АПИ, а на выходе возвращает готовый хук для работы с ней
 * обновленный стиль. Не использует стейт для хранения ошибок и данных, а вызывает переданные 
 * onError и onData
 */
const createUseFunction2 = (apiSender) => (onData, onError) => {
    const sender = useCallback((sendData) => {
        apiSender(sendData)
            .then(result => onData(result))
            .catch(error => onError(error))
    }, [onData, onError])

    return sender;
}

/**
 * хук для выполнения логина пользователя
 * возвращает массив из [data, err, sender, reset], где
 * data - результат выполнения запроса к АПИ
 * err - ошибки возникшие в результате запроса к АПИ
 * sender - ф-ция выполняющая отправку запроса (в качестве параметра ожидает тело запроса)
 * reset - ф-ция сбрасывающия результат запроса и ошибки
 */
const useLogin = createUseFunction(login);

/**
 * хук для выполнения логаута пользователя
 * возвращает массив из [data, err, sender, reset], где
 * data - результат выполнения запроса к АПИ
 * err - ошибки возникшие в результате запроса к АПИ
 * sender - ф-ция выполняющая отправку запроса (в качестве параметра ожидает тело запроса)
 * reset - ф-ция сбрасывающия результат запроса и ошибки
 */
const useLogout = createUseFunction(logout);

/**
 * хук для запроса данных по ЧЗ-коду из нашей базы
 * возвращает массив из [data, err, sender, reset], где
 * data - результат выполнения запроса к АПИ
 * err - ошибки возникшие в результате запроса к АПИ
 * sender - ф-ция выполняющая отправку запроса (в качестве параметра ожидает тело запроса)
 * reset - ф-ция сбрасывающия результат запроса и ошибки
 */
const useCheckCode = createUseFunction(checkCode);

/**
 * хук для отправки данных карты в базу
 * возвращает массив из [data, err, sender, reset], где
 * data - результат выполнения запроса к АПИ
 * err - ошибки возникшие в результате запроса к АПИ
 * sender - ф-ция выполняющая отправку запроса (в качестве параметра ожидает тело запроса)
 * reset - ф-ция сбрасывающия результат запроса и ошибки
 */
const useSendCard = createUseFunction(sendCard);

/**
 * хук для получения настроек текущей формы
 * возвращает функцию, выполняющую загрузку настроек,
 * получает два колбека onData, onError которые вызываются
 * при успешном и неуспешном результате загрузки соответсвенно
 */
const useGetSettings = createUseFunction2(getSettings)

/**
 * хук для поиска товара по части названия или части 1с кода
 * возвращает  функцию, выполняющую поиск продукта в базе,
 * получает два колбека onData, onError которые вызываются
 * при успешном и неуспешном результате загрузки соответсвенно
 */
const useFindProduct = createUseFunction2(findProduct)


export {useLogin, useLogout, useCheckCode, useSendCard, useGetSettings, useFindProduct}

